/**
 * 后端 Pydantic 模型对应的 TS 类型。
 * 真实运行时校验由各 feature 自己用 zod schema 做; 这里只提供 IDE 提示。
 */

export type UserRole = "user" | "company_admin" | "super_admin";

export interface LoginUser {
  id: number;
  username: string;
  display_name?: string;
  role: UserRole;
  company_id: number | null;
  company_name?: string | null;
}

/** 登录成功 (/api/login, /api/login/select, /api/login/sms, /api/register 同构) */
export interface LoginSuccess {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in?: number;
  user: LoginUser;
}

export interface TenantChoice {
  user_id: number;
  company_id: number | null;
  company_name: string | null;
  company_type: "org" | "personal" | null;
  username: string;
  display_name?: string | null;
  role: UserRole;
}

/** 同一账号命中多家公司: 用 ticket + user_id 调 /api/login/select */
export interface SelectTenantResponse {
  status: "select_tenant";
  ticket: string;
  choices: TenantChoice[];
}

export type LoginResponse = LoginSuccess | SelectTenantResponse;

export function isSelectTenant(r: LoginResponse): r is SelectTenantResponse {
  return (r as SelectTenantResponse).status === "select_tenant";
}

export type DeploymentMode = "single" | "multi" | "saas";

export interface PublicConfig {
  deployment_mode: DeploymentMode;
  sms_login_enabled: boolean;
  register_enabled: boolean;
  credits_enabled: boolean;
  credit_price_quote_fen: number;
  credit_price_image_fen: number;
  sms_resend_interval_seconds: number;
}

/** 报价完成时服务端留存的快照 (quote_sessions.quote_json), 字段名同 SmartQuoteResponse */
export interface StoredQuote {
  calculation_details?: Array<Record<string, unknown>>;
  extracted_params?: Array<Record<string, unknown>>;
  total_price?: number;
}

export interface SessionTurn {
  seq: number;
  role: "user" | "assistant";
  content: string;
  ts: string;
  /** assistant 轮次: 报价快照; 追问 / 旧数据为 null */
  quote?: StoredQuote | null;
}

export interface SmartQuoteResponse {
  success: boolean;
  quote_response?: string;
  calculation_details?: Array<Record<string, unknown>>;
  extracted_params?: Array<Record<string, unknown>>;
  total_price?: number;
  needs_clarification: boolean;
  error?: string;
  session_id?: string;
  session_turns?: SessionTurn[];
  turn_seq?: number;
}

export interface ProductInfo {
  key: string;
  name: string;
  calc_strategy: string;
}
